import { __ } from '~/locale';

export const VERIFICATION_REQUIRED_MESSAGE = __('Complete verification to sign up.');
export const VERIFICATION_LOADING_MESSAGE = __('Please wait while we prepare for verification.');

export const CHALLENGE_CONTAINER_CLASS = 'js-arkose-labs-container-';
export const VERIFICATION_TOKEN_INPUT_NAME = 'arkose_labs_token';
